module.exports = __webpack_public_path__ + "media/images/flags/pt-b89a5b80ca1a71c3b96a85fe858b62da.svg";